import { QuestionBase } from '@jump-tech-frontend/domain';
import { LikertQuestionParams } from './questions/likert/likert.model';
import { TextareaQuestionParams } from './questions/textarea/textarea.model';
import { TextboxQuestionParams } from './questions/textbox/textbox.model';
import { ModalQuestionParams } from './questions/modal/modal.model';
import { Questions } from './questions/question.model';
import { TextboxQuestion } from '../../../domain/src/lib/question-components/text-box-question';
import { VideoCaptureQuestionParams } from './questions/video/video-capture.model';

export function getQuestionParams(question: QuestionBase<unknown>, currentQuestionValue: string): unknown {
  switch (question.controlType) {
    case Questions.TextareaQuestion:
      return cardQuestionToTextareaQuestionParamsTransformer(question as QuestionBase<string>, currentQuestionValue);
    case Questions.LikertQuestion:
      return cardQuestionToLikertQuestionParamsTransformer(question as QuestionBase<string>, currentQuestionValue);
    case Questions.ModalQuestion:
      return cardQuestionToModalQuestionParamsTransformer(question as QuestionBase<string>);
    case Questions.VideoQuestion:
      return cardQuestionToVideoQuestionParamsTransformer(question as QuestionBase<string[]>);
    default:
      return cardQuestionToTextboxQuestionParamsTransformer(question as TextboxQuestion, currentQuestionValue);
  }
}

export function getVideoQuestionParams(question: QuestionBase<string[]>, value: string[]): VideoCaptureQuestionParams {
  return cardQuestionToVideoQuestionParamsTransformer(question, value);
}

export function cardQuestionToTextboxQuestionParamsTransformer(
  question: TextboxQuestion,
  currentQuestionValue: string
): TextboxQuestionParams {
  return {
    key: question.key,
    label: question.label,
    required: question.required,
    value: currentQuestionValue ?? question.value,
    inline: question.inline
  };
}

export function cardQuestionToTextareaQuestionParamsTransformer(
  question: QuestionBase<string>,
  currentQuestionValue: string
): TextareaQuestionParams {
  return {
    key: question.key,
    label: question.label,
    required: question.required,
    value: currentQuestionValue ?? question.value
  };
}

export function cardQuestionToModalQuestionParamsTransformer(question: QuestionBase<string>): ModalQuestionParams {
  return {
    key: question.key,
    label: question.label,
    content: question.content,
    hint: question.hint,
    required: question.required,
    actionLabel: question.actionLabel
  };
}

export function cardQuestionToVideoQuestionParamsTransformer(
  question: QuestionBase<string[]>,
  value?: string[]
): VideoCaptureQuestionParams {
  return {
    key: question.key,
    label: question.label,
    hint: question.hint,
    required: question.required,
    value: value ?? question.value
  };
}

export function cardQuestionToLikertQuestionParamsTransformer(
  question: QuestionBase<string>,
  currentQuestionValue: string
): LikertQuestionParams {
  return {
    key: question.key,
    label: question.label,
    required: question.required,
    value: currentQuestionValue ?? question.value,
    bottomHint: question.bottomHint,
    topHint: question.topHint,
    steps: question.likertSteps
  };
}
